var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"min-height":"600px"}},[_c('h2',[_vm._v("Management Report")]),_vm._v("\n To be done...\n  "),_c('v-spacer'),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }